@if (selectedLanguage) {
  <div class="language-switcher">
    <mat-radio-group
      class="language-radio-group"
      [value]="selectedLanguage"
      (change)="onChangeLanguage($event.value)"
    >
      <mat-radio-button class="radio-item" [value]="languageEnum.EN"> En </mat-radio-button>
      <mat-radio-button class="radio-item" [value]="languageEnum.NO"> No </mat-radio-button>
    </mat-radio-group>
  </div>
}
